// extracted by mini-css-extract-plugin
module.exports = {"title":"rXOv1H","additionalInfoLine":"p68NtN","top-divider":"EkF8XV","topDivider":"EkF8XV","bottom-divider":"xQDcuS","bottomDivider":"xQDcuS"};